module.exports = __webpack_public_path__ + "static/img/img_serve1.cba90e76.png";